import * as smsAuthActions from '../actions/smsAuth';

const initialState = {
    showVerifySmsInput: false,
    smsAuthStatus: 'pending',
    errors: {},
}

export default(state = initialState, action) => {
    switch(action.type){
        case smsAuthActions.SHOW_VERIFY_CODE_INPUT:
            return {
                ...state,
                showVerifySmsInput: true
            }

        case smsAuthActions.HIDE_VERIFY_CODE_INPUT:
            return {
                ...state,
                showVerifySmsInput: false
            }

        case smsAuthActions.SET_SMS_AUTH_ERRORS:
            return {
                ...state,
                errors: action.errors
            }

        case smsAuthActions.UPDATE_SMS_AUTH_STATUS:
            return {
                ...state,
                smsAuthStatus: action.smsAuthStatus
            }

        default:
            return state;
    }
}
